export const selectClips = state => state.clips.clips